module.exports = __webpack_public_path__ + "static/img/infiared.959beff6.png";